type Row = {
  label: string;
  value: string;
  note?: string;
};

const specs: Row[] = [
  {
    label: 'Sprachen',
    value: 'DE · EN · FR · IT · NL · ES',
    note: 'multilingualer Decoder · Fine-Tune pro Kunde',
  },
  {
    label: 'Layouts',
    value: 'Text · Tabellen · Formeln · Figuren',
    note: 'inkl. Listen, Captions, Lesereihenfolge',
  },
  { label: 'Eingabe', value: 'PDF · TIFF · PNG · JPG', note: 'einseitig oder mehrseitig' },
  { label: 'Ausgabe', value: 'JSON · Markdown', note: 'Tabellen → HTML, Formeln → LaTeX' },
  {
    label: 'Qualität',
    value: 'Konfidenz pro Wort und Feld',
    note: 'transparente Unsicherheit, keine stillen Fehler',
  },
  { label: 'Schnittstelle', value: 'REST + API-Key', note: 'pro Kunde isoliert' },
  { label: 'Betrieb', value: 'On-prem oder gehostet', note: 'NVIDIA-GPUs, EU-Hardware' },
];

export default function OcrCapability() {
  return (
    <section id="ocr" className="border-b border-rule">
      <div className="mx-auto max-w-[1280px] px-6 py-20 md:px-10 md:py-28">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="label-mono mb-6 text-accent">— 02 / Lieferumfang</p>
            <h2 className="text-3xl font-bold uppercase tracking-[-0.01em] text-ink md:text-4xl">
              OCR, die in Produktion läuft<span className="text-accent">.</span>
            </h2>
            <p className="mt-6 max-w-md text-fg-muted">
              Nicht Demo, nicht Notebook. Eine REST-API, dahinter ein gewartetes Modell auf GPUs in
              Deutschland. Tabellen als HTML, Formeln als LaTeX, Konfidenz pro Wort und Feld. SLA
              und signierte Audit-Logs.
            </p>
            <ul className="mt-8 space-y-3 text-sm text-fg-muted">
              <li className="flex gap-3">
                <span className="text-accent">▸</span> Pilot in 2–4 Wochen, gegen Ihre eigenen
                Dokumente getestet
              </li>
              <li className="flex gap-3">
                <span className="text-accent">▸</span> On-prem in Ihrem Rechenzentrum, Air-Gap
                möglich
              </li>
              <li className="flex gap-3">
                <span className="text-accent">▸</span> Datenrückgabe & vollständige Löschung
                vertraglich zugesichert
              </li>
            </ul>
          </div>

          <div className="md:col-span-7">
            <div className="border border-rule bg-bg-elev">
              <div className="border-b border-rule px-6 py-3 font-mono text-[11px] uppercase tracking-[0.12em] text-fg-muted">
                <span className="font-semibold text-accent">spec</span> · ocr.v1
              </div>
              <dl className="grid grid-cols-1 sm:grid-cols-2">
                {specs.map((row) => (
                  <div
                    key={row.label}
                    className="border-b border-rule px-6 py-5 last:border-b-0 sm:[&:nth-last-child(-n+2)]:border-b-0 sm:odd:border-r sm:[&:last-child:nth-child(odd)]:col-span-2 sm:[&:last-child:nth-child(odd)]:!border-r-0"
                  >
                    <dt className="font-mono text-[12px] uppercase tracking-[0.14em] text-fg-muted">
                      {row.label}
                    </dt>
                    <dd className="mt-2 text-base font-medium text-ink">{row.value}</dd>
                    {row.note ? <dd className="mt-1 text-xs text-fg-muted">{row.note}</dd> : null}
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
